import { SceneSetGraph } from '@bighealth/types';

import CarouselMenu from './CarouselMenu';
import ListMenu from './ListMenu';

export { CarouselMenu, ListMenu };

export type MenuItem = {
  sceneSetGraph: SceneSetGraph;
};

export type MenuProps = {
  items: MenuItem[];
};
